import {
  DiagnosticsStackGenericResponse,
  RemoteDiagnosticsSuccessResponseData,
  RemoteDiagnosticsVddRootMetadataResponse,
  RemoteDiagnosticsVddRootStructureResponse,
} from '../remote-diagnostics.model';
import { MockedVdd } from './MockedVdd.model';
import { VddNames } from '../../../../../app/+installations/diagnostics-overlay/tabs-content/extended-parameters/diagnostics-constants';

export class BusIdentification implements MockedVdd {
  readSingleSync(logicalLink?: string): RemoteDiagnosticsSuccessResponseData {
    return {
      RES:
        ' 62 01 00 01 02 02 03 02 00 0D 02 4A 08 0B 02 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00',
      request_parameter_name: 'PA_DataIdent',
      service: 'DS_ReadDataByIdent',
      ecu: logicalLink ?? 'LL_0020_HPMU_CAN01',
      requestDate: new Date().toISOString(),
      ecuvariant: logicalLink ?? 'LL_0020_HPMU_CAN01',
      request_parameter_value: VddNames.BusIdentification,
      securitystatus: '',
      type: 'ReadVddDataByVdd',
      structure: [
        {
          semantic: 'SERVICE-ID',
          path: 'PA_ServiID',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_ServiID',
          value: '98',
        },
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'BusIdentification',
        },
        {
          semantic: '',
          path: 'PA_DataRecor',
          translationid: '',
          dopname: '2 Byte Table VDD Greenbook',
          name: 'PA_DataRecor',
          structure: [
            {
              semantic: 'VALUE',
              path: 'PA_DataRecor/PA_BusAddre',
              unit: '',
              translationid: 'TI_BusAddress',
              dopname: '1 Byte Identical uint8 Hex',
              name: 'PA_BusAddre',
              value: '1',
            },
            {
              semantic: 'ENUM',
              path: 'PA_DataRecor/PA_BusType',
              unit: '',
              translationid: 'TI_BusType',
              dopname: '1 Byte TextTable BusType',
              name: 'PA_BusType',
              value: 'CanInternal',
            },
            {
              semantic: 'ENUM',
              path: 'PA_DataRecor/PA_DevicObjecPrope',
              unit: '',
              translationid: 'TI_DeviceObjectProperty',
              dopname: '1 Byte TextTable DeviceObjectProperty',
              name: 'PA_DevicObjecPrope',
              value: 'HMUMaster',
            },
            {
              semantic: 'ENUM',
              path: 'PA_DataRecor/PA_DevicFunct',
              translationid: 'TI_DeviceFunction',
              dopname: '1 Byte Table DeviceObjectProperty',
              name: 'PA_DevicFunct',
              structure: [
                {
                  semantic: 'ENUMCHOICE',
                  path: 'PA_DataRecor/PA_DevicFunct/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  dopname: '1 Byte TextTable uint8 HMUDeviceFunction',
                  name: 'PA_DevicFunct',
                  value: 'VitodensTwoHundred',
                },
              ],
            },
            {
              semantic: 'SOFTWAREVERSION',
              path: 'PA_DataRecor/PA_SoftwVersi',
              translationid: 'TI_SoftwareVersion',
              dopname: '8 Byte Structure SoftwareVersion',
              name: 'PA_SoftwVersi',
              structure: [
                {
                  semantic: 'VERSIONVALUE',
                  path: 'PA_DataRecor/PA_SoftwVersi/PA_Famil',
                  unit: '',
                  translationid: 'TI_Family',
                  dopname: '2 Byte Identical uint16',
                  name: 'PA_Famil',
                  value: '2',
                },
                {
                  semantic: 'VERSIONVALUE',
                  path: 'PA_DataRecor/PA_SoftwVersi/PA_Versi',
                  unit: '',
                  translationid: 'TI_Version',
                  dopname: '2 Byte Identical uint16',
                  name: 'PA_Versi',
                  value: '525',
                },
                {
                  semantic: 'VERSIONVALUE',
                  path: 'PA_DataRecor/PA_SoftwVersi/PA_Revis',
                  unit: '',
                  translationid: 'TI_Revision',
                  dopname: '2 Byte Identical uint16',
                  name: 'PA_Revis',
                  value: '2122',
                },
                {
                  semantic: 'VERSIONVALUE',
                  path: 'PA_DataRecor/PA_SoftwVersi/PA_Build',
                  unit: '',
                  translationid: 'TI_Build',
                  dopname: '2 Byte Identical uint16',
                  name: 'PA_Build',
                  value: '523',
                },
              ],
            },
            {
              semantic: 'HARDWAREVERSION',
              path: 'PA_DataRecor/PA_HardwVersi',
              translationid: 'TI_HardwareVersion',
              dopname: '8 Byte Structure HardwareVersion',
              name: 'PA_HardwVersi',
              structure: [
                {
                  semantic: 'VERSIONVALUE',
                  path: 'PA_DataRecor/PA_HardwVersi/PA_Famil',
                  unit: '',
                  translationid: 'TI_Family',
                  dopname: '2 Byte Identical uint16',
                  name: 'PA_Famil',
                  value: '0',
                },
                {
                  semantic: 'VERSIONVALUE',
                  path: 'PA_DataRecor/PA_HardwVersi/PA_Versi',
                  unit: '',
                  translationid: 'TI_Version',
                  dopname: '2 Byte Identical uint16',
                  name: 'PA_Versi',
                  value: '0',
                },
                {
                  semantic: 'VERSIONVALUE',
                  path: 'PA_DataRecor/PA_HardwVersi/PA_Revis',
                  unit: '',
                  translationid: 'TI_Revision',
                  dopname: '2 Byte Identical uint16',
                  name: 'PA_Revis',
                  value: '0',
                },
                {
                  semantic: 'VERSIONVALUE',
                  path: 'PA_DataRecor/PA_HardwVersi/PA_AssemVaria',
                  unit: '',
                  translationid: 'TI_AssemblyVariant',
                  dopname: '2 Byte Identical uint16',
                  name: 'PA_AssemVaria',
                  value: '0',
                },
              ],
            },
            {
              semantic: 'TARCEABILITY',
              path: 'PA_DataRecor/PA_ElectTraceNumbe',
              translationid: 'TI_ElectronicTraceabilityNumber',
              dopname: '16 Byte Structure VinModul',
              name: 'PA_ElectTraceNumbe',
              structure: [
                {
                  semantic: 'ITEMID',
                  path: 'PA_DataRecor/PA_ElectTraceNumbe/PA_ItemId',
                  unit: '',
                  translationid: 'TI_ItemId',
                  dopname: '7 Byte Identical ItemId',
                  name: 'PA_ItemId',
                  value: '',
                },
                {
                  semantic: 'PRODUCTIONYEAR',
                  path: 'PA_DataRecor/PA_ElectTraceNumbe/PA_Year',
                  unit: '',
                  translationid: 'TI_Year',
                  dopname: '1 Byte Identical uint8 ASCII',
                  name: 'PA_Year',
                  value: '',
                },
                {
                  semantic: 'COUNTER',
                  path: 'PA_DataRecor/PA_ElectTraceNumbe/PA_ProceCount',
                  unit: '',
                  translationid: 'TI_ProcessCounter',
                  dopname: '5 Byte Identical ProcessCounter',
                  name: 'PA_ProceCount',
                  value: '',
                },
                {
                  semantic: 'COUNTER',
                  path: 'PA_DataRecor/PA_ElectTraceNumbe/PA_OverfCountOne',
                  unit: '',
                  translationid: 'TI_OverflowCounterOne',
                  dopname: '1 Byte Identical uint8 ASCII',
                  name: 'PA_OverfCountOne',
                  value: '',
                },
                {
                  semantic: 'COUNTER',
                  path: 'PA_DataRecor/PA_ElectTraceNumbe/PA_OverfTwo',
                  unit: '',
                  translationid: 'TI_OverflowTwo',
                  dopname: '1 Byte Identical uint8 ASCII',
                  name: 'PA_OverfTwo',
                  value: '',
                },
                {
                  semantic: 'VALUE',
                  path: 'PA_DataRecor/PA_ElectTraceNumbe/PA_Check',
                  unit: '',
                  translationid: 'TI_Checksum',
                  dopname: '1 Byte Identical uint8 ASCII',
                  name: 'PA_Check',
                  value: '',
                },
              ],
            },
          ],
        },
        {
          semantic: '',
          path: 'PA_RecorDataIdentCheck',
          unit: '',
          translationid: '',
          dopname: '',
          name: 'PA_RecorDataIdentCheck',
          value: '',
        },
      ],
      REQ: ' 22 01 00',
    };
  }

  metadata(): RemoteDiagnosticsVddRootMetadataResponse {
    return {
      request_parameter_name: 'PA_Param',
      service: 'DS_VDDMetaData',
      ecu: 'LL_0002_HMU_CAN01',
      request_parameter_value: VddNames.BusIdentification,
      type: 'MetaDataByVddAndBaseVariant',
      structure: [
        {
          semantic: '',
          longname: 'Param',
          byteposition: '0',
          dopname: '2 Byte Text Table VDD-Greenbook',
          precision: '',
          byteLength: '16',
          type: 'eKEY',
          shortname: 'PA_Param',
          constraints: '',
          path: 'PA_Param',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Param',
          interval: '256',
          value: 'BusIdentification',
        },
        {
          semantic: '',
          longname: 'Value',
          byteposition: '2',
          dopname: '2 Byte Table VDD MetaData',
          precision: '',
          byteLength: '-1',
          type: 'eTABLE',
          shortname: 'PA_Value',
          constraints: '',
          structure: [
            {
              semantic: 'MODIFIABLE',
              longname: 'Modifiable',
              byteposition: '0',
              dopname: '1 Byte TextTable FalseTrue',
              precision: '',
              byteLength: '8',
              type: 'eTEXTTABLE',
              shortname: 'PA_Modif',
              constraints: '',
              structure: [
                { TI_texttableentry: 'TI_False', interval: '0', texttableentry: 'False' },
                { TI_texttableentry: 'TI_True', interval: '1', texttableentry: 'True' },
              ],
              path: 'PA_Value/PA_Modif',
              unit: '',
              translationid: 'TI_Modifiable',
              bitposition: '0',
              name: 'PA_Modif',
              value: 'False',
            },
          ],
          path: 'PA_Value',
          unit: '',
          translationid: '',
          bitposition: '0',
          name: 'PA_Value',
          value: '',
        },
      ],
    };
  }

  structure(): DiagnosticsStackGenericResponse<RemoteDiagnosticsVddRootStructureResponse[]> {
    return {
      type: 'VddStructureByVddAndBaseVariant',
      structure: [
        {
          request_parameter_name: 'PA_Param',
          service: 'DS_VDDPAStruc',
          ecu: 'LL_0002_HMU_CAN01',
          request_parameter_value: VddNames.BusIdentification,
          type: 'RequestStructureByParameterNameAndValue',
          structure: [
            {
              semantic: '',
              longname: 'Param',
              byteposition: '0',
              dopname: '2 Byte Text Table VDD-Greenbook',
              precision: '',
              byteLength: '16',
              type: 'eKEY',
              shortname: 'PA_Param',
              constraints: '',
              path: 'PA_Param',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Param',
              interval: '256',
              value: 'BusIdentification',
            },
            {
              semantic: '',
              longname: 'Structure',
              byteposition: '2',
              dopname: '2 Byte Table VDD Greenbook',
              precision: '',
              byteLength: '-1',
              type: 'eTABLE',
              shortname: 'PA_Struc',
              constraints: '',
              structure: [
                {
                  semantic: 'VALUE',
                  longname: 'BusAddress',
                  byteposition: '0',
                  dopname: '1 Byte Identical uint8 Hex',
                  precision: '',
                  byteLength: '8',
                  type: 'eA_UINT32',
                  shortname: 'PA_BusAddre',
                  constraints: '[0:255]',
                  path: 'PA_Struc/PA_BusAddre',
                  unit: '',
                  translationid: 'TI_BusAddress',
                  bitposition: '0',
                  name: 'PA_BusAddre',
                  value: '0',
                },
                {
                  semantic: 'ENUM',
                  longname: 'BusType',
                  byteposition: '1',
                  dopname: '1 Byte TextTable BusType',
                  precision: '',
                  byteLength: '8',
                  type: 'eTEXTTABLE',
                  shortname: 'PA_BusType',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_OwnBus', interval: '0', texttableentry: 'OwnBus' },
                    { TI_texttableentry: 'TI_PlusBus', interval: '1', texttableentry: 'PlusBus' },
                    {
                      TI_texttableentry: 'TI_CanInternal',
                      interval: '2',
                      texttableentry: 'CanInternal',
                    },
                    {
                      TI_texttableentry: 'TI_CanExternal',
                      interval: '3',
                      texttableentry: 'CanExternal',
                    },
                    {
                      TI_texttableentry: 'TI_InternalUart',
                      interval: '4',
                      texttableentry: 'InternalUart',
                    },
                    { TI_texttableentry: 'TI_Zigbee', interval: '5', texttableentry: 'Zigbee' },
                    { TI_texttableentry: 'TI_CanRaw', interval: '6', texttableentry: 'CanRaw' },
                    { TI_texttableentry: 'TI_Unkown', interval: '7', texttableentry: 'Unkown' },
                    { TI_texttableentry: 'TI_ModBus', interval: '8', texttableentry: 'ModBus' },
                    { TI_texttableentry: 'TI_EEBUS', interval: '9', texttableentry: 'EEBUS' },
                    {
                      TI_texttableentry: 'TI_PlusBusTwo',
                      interval: '10',
                      texttableentry: 'PlusBusTwo',
                    },
                    {
                      TI_texttableentry: 'TI_ISquaredCBus',
                      interval: '11',
                      texttableentry: 'ISquaredCBus',
                    },
                    {
                      TI_texttableentry: 'TI_HemsBus',
                      interval: '12',
                      texttableentry: 'HemsBus',
                    },
                    {
                      TI_texttableentry: 'TI_SolarLogBus',
                      interval: '13',
                      texttableentry: 'SolarLogBus',
                    },
                    {
                      TI_texttableentry: 'TI_ServiceBus',
                      interval: '14',
                      texttableentry: 'ServiceBus',
                    },
                  ],
                  path: 'PA_Struc/PA_BusType',
                  unit: '',
                  translationid: 'TI_BusType',
                  bitposition: '0',
                  name: 'PA_BusType',
                  value: 'OwnBus',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'Nothing',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'BackendGateway',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'ENUM',
                      path: 'PA_Struc/PA_DevicFunct/PA_BackeGatew',
                      unit: '',
                      dopname: '1 Byte TextTable BackendGateway',
                      name: 'PA_BackeGatew',
                      value: 'Nothing',
                      structure: [
                        {
                          TI_texttableentry: 'TI_Nothing',
                          interval: '0',
                          texttableentry: 'Nothing',
                        },
                        {
                          TI_texttableentry: 'TI_BackendLan',
                          interval: '1',
                          texttableentry: 'BackendLan',
                        },
                        {
                          TI_texttableentry: 'TI_BackendWlan',
                          interval: '2',
                          texttableentry: 'BackendWlan',
                        },
                        {
                          TI_texttableentry: 'TI_BackendNbiot',
                          interval: '3',
                          texttableentry: 'BackendNbiot',
                        },
                        {
                          TI_texttableentry: 'TI_BackendLanNbiot',
                          interval: '4',
                          texttableentry: 'BackendLanNbiot',
                        },
                        {
                          TI_texttableentry: 'TI_BackendWlanNbiot',
                          interval: '5',
                          texttableentry: 'BackendWlanNbiot',
                        },
                        {
                          TI_texttableentry: 'TI_BackendLanWlanNbiot',
                          interval: '6',
                          texttableentry: 'BackendLanWlanNbiot',
                        },
                      ],
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'HMUMaster',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path: 'PA_Struc/PA_DevicFunct/PA_DevicFunct',
                      unit: '',
                      dopname: '1 Byte TextTable uint8 HMUDeviceFunction',
                      name: 'PA_DevicFunct',
                      value: 'Nothing',
                      structure: [
                        {
                          TI_texttableentry: 'TI_Nothing',
                          interval: '0',
                          texttableentry: 'Nothing',
                        },
                        {
                          TI_texttableentry: 'TI_VitodensThreeHundred',
                          interval: '1',
                          texttableentry: 'VitodensThreeHundred',
                        },
                        {
                          TI_texttableentry: 'TI_Vitovalor',
                          interval: '2',
                          texttableentry: 'Vitovalor',
                        },
                        {
                          TI_texttableentry: 'TI_VitodensTwoHundred',
                          interval: '3',
                          texttableentry: 'VitodensTwoHundred',
                        },
                        {
                          TI_texttableentry: 'TI_VitovalorStandalone',
                          interval: '5',
                          texttableentry: 'VitovalorStandalone',
                        },
                        {
                          TI_texttableentry: 'TI_VitodensTwoHundredNorthAmerica',
                          interval: '8',
                          texttableentry: 'VitodensTwoHundredNorthAmerica',
                        },
                        {
                          TI_texttableentry: 'TI_VitodensOneHundredNorthAmerica',
                          interval: '9',
                          texttableentry: 'VitodensOneHundredNorthAmerica',
                        },
                        {
                          TI_texttableentry: 'TI_VitocrossalTwoHundredSingleBurner',
                          interval: '10',
                          texttableentry: 'VitocrossalTwoHundredSingleBurner',
                        },
                        {
                          TI_texttableentry: 'TI_VitocrossalTwoHundredDoubleBurner',
                          interval: '11',
                          texttableentry: 'VitocrossalTwoHundredDoubleBurner',
                        },
                        {
                          TI_texttableentry: 'TI_VitocrossalTwoHundredTripleBurner',
                          interval: '12',
                          texttableentry: 'VitocrossalTwoHundredTripleBurner',
                        },
                        {
                          TI_texttableentry: 'TI_VitovalorStandaloneHexis',
                          interval: '13',
                          texttableentry: 'VitovalorStandaloneHexis',
                        },
                      ],
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'HMUSlave',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path: 'PA_Struc/PA_DevicFunct/PA_DevicFunct',
                      unit: '',
                      dopname: '1 Byte TextTable uint8 HMUSlaveFunction',
                      name: 'PA_DevicFunct',
                      value: 'Nothing',
                      structure: [
                        {
                          TI_texttableentry: 'TI_Nothing',
                          interval: '0',
                          texttableentry: 'Nothing',
                        },
                        {
                          TI_texttableentry: 'TI_VitodensThreeHundred',
                          interval: '1',
                          texttableentry: 'VitodensThreeHundred',
                        },
                        {
                          TI_texttableentry: 'TI_Vitovalor',
                          interval: '2',
                          texttableentry: 'Vitovalor',
                        },
                        {
                          TI_texttableentry: 'TI_VitodensTwoHundred',
                          interval: '3',
                          texttableentry: 'VitodensTwoHundred',
                        },
                        {
                          TI_texttableentry: 'TI_VitolignoTwoHundred',
                          interval: '4',
                          texttableentry: 'VitolignoTwoHundred',
                        },
                        {
                          TI_texttableentry: 'TI_VitovalorStandalone',
                          interval: '5',
                          texttableentry: 'VitovalorStandalone',
                        },
                        {
                          TI_texttableentry: 'TI_VitodensOneHundred',
                          interval: '6',
                          texttableentry: 'VitodensOneHundred',
                        },
                        {
                          TI_texttableentry: 'TI_VitodensZeroFifty',
                          interval: '7',
                          texttableentry: 'VitodensZeroFifty',
                        },
                        {
                          TI_texttableentry: 'TI_VitodensTwoHundredNorthAmerica',
                          interval: '8',
                          texttableentry: 'VitodensTwoHundredNorthAmerica',
                        },
                        {
                          TI_texttableentry: 'TI_VitodensOneHundredNorthAmerica',
                          interval: '9',
                          texttableentry: 'VitodensOneHundredNorthAmerica',
                        },
                        {
                          TI_texttableentry: 'TI_VitocrossalTwoHundredSingleBurner',
                          interval: '10',
                          texttableentry: 'VitocrossalTwoHundredSingleBurner',
                        },
                        {
                          TI_texttableentry: 'TI_VitocrossalTwoHundredDoubleBurner',
                          interval: '11',
                          texttableentry: 'VitocrossalTwoHundredDoubleBurner',
                        },
                        {
                          TI_texttableentry: 'TI_VitocrossalTwoHundredTripleBurner',
                          interval: '12',
                          texttableentry: 'VitocrossalTwoHundredTripleBurner',
                        },
                      ],
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'MCUMaster',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable DeviceFunctionMCU',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        {
                          TI_texttableentry: 'TI_Nothing',
                          interval: '0',
                          texttableentry: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'Nothing',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'MCUSlave',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable DeviceFunctionMCU',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        {
                          TI_texttableentry: 'TI_Nothing',
                          interval: '0',
                          texttableentry: 'Nothing',
                        },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'Nothing',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'HMI',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'BCU',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'GasAirRatioSystem',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'ADIO',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable GenericAnalogDigitalAccessoryFunction',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        {
                          TI_texttableentry: 'TI_Nothing',
                          interval: '0',
                          texttableentry: 'Nothing',
                        },
                        {
                          TI_texttableentry: 'TI_Individual',
                          interval: '1',
                          texttableentry: 'Individual',
                        },
                        {
                          TI_texttableentry: 'TI_MixerCircuitWithHydraulicSeparatorSensor',
                          interval: '2',
                          texttableentry: 'MixerCircuitWithHydraulicSeparatorSensor',
                        },
                        {
                          TI_texttableentry: 'TI_MixerCircuitWithoutHydraulicSeparatorSensor',
                          interval: '3',
                          texttableentry: 'MixerCircuitWithoutHydraulicSeparatorSensor',
                        },
                        { TI_texttableentry: 'TI_Solar', interval: '6', texttableentry: 'Solar' },
                        {
                          TI_texttableentry: 'TI_PumpModule',
                          interval: '12',
                          texttableentry: 'PumpModule',
                        },
                        {
                          TI_texttableentry: 'TI_BufferDischarge',
                          interval: '13',
                          texttableentry: 'BufferDischarge',
                        },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'Nothing',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'DIO',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable GenericDigitalAccessoryFunction',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        {
                          TI_texttableentry: 'TI_Nothing',
                          interval: '0',
                          texttableentry: 'Nothing',
                        },
                        {
                          TI_texttableentry: 'TI_Individual',
                          interval: '1',
                          texttableentry: 'Individual',
                        },
                        {
                          TI_texttableentry: 'TI_ElectricalHeater',
                          interval: '3',
                          texttableentry: 'ElectricalHeater',
                        },
                        {
                          TI_texttableentry: 'TI_ExternalFlowSetpoint',
                          interval: '4',
                          texttableentry: 'ExternalFlowSetpoint',
                        },
                        {
                          TI_texttableentry: 'TI_ExternalModulationSetpoint',
                          interval: '5',
                          texttableentry: 'ExternalModulationSetpoint',
                        },
                        {
                          TI_texttableentry: 'TI_ExhaustFlap',
                          interval: '7',
                          texttableentry: 'ExhaustFlap',
                        },
                        {
                          TI_texttableentry: 'TI_FaultSignal',
                          interval: '8',
                          texttableentry: 'FaultSignal',
                        },
                        {
                          TI_texttableentry: 'TI_ExternalLiquidGasValve',
                          interval: '9',
                          texttableentry: 'ExternalLiquidGasValve',
                        },
                        {
                          TI_texttableentry: 'TI_KitchenHood',
                          interval: '10',
                          texttableentry: 'KitchenHood',
                        },
                        {
                          TI_texttableentry: 'TI_NiveauSwitchCentral',
                          interval: '11',
                          texttableentry: 'NiveauSwitchCentral',
                        },
                        {
                          TI_texttableentry: 'TI_DhwCirculation',
                          interval: '13',
                          texttableentry: 'DhwCirculation',
                        },
                        {
                          TI_texttableentry: 'TI_CondensateLiftPump',
                          interval: '14',
                          texttableentry: 'CondensateLiftPump',
                        },
                        {
                          TI_texttableentry: 'TI_ExternalLiquidGasValveWithFeedback',
                          interval: '16',
                          texttableentry: 'ExternalLiquidGasValveWithFeedback',
                        },
                        {
                          TI_texttableentry: 'TI_FaultSignalAndLocked',
                          interval: '17',
                          texttableentry: 'FaultSignalAndLocked',
                        },
                        {
                          TI_texttableentry: 'TI_ExternalHeatDemand',
                          interval: '18',
                          texttableentry: 'ExternalHeatDemand',
                        },
                        {
                          TI_texttableentry: 'TI_ExternalLocked',
                          interval: '19',
                          texttableentry: 'ExternalLocked',
                        },
                        {
                          TI_texttableentry: 'TI_ZoneControlSimple',
                          interval: '20',
                          texttableentry: 'ZoneControlSimple',
                        },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'Nothing',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'KnxGateway',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: '',
                      path: 'PA_Struc/PA_DevicFunct/PA_Funct',
                      unit: '',
                      dopname: '1 Byte TextTable EnergyMeter',
                      name: 'PA_Funct',
                      value: 'No',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        {
                          TI_texttableentry: 'TI_Source',
                          interval: '1',
                          texttableentry: 'Source',
                        },
                        {
                          TI_texttableentry: 'TI_Consumer',
                          interval: '2',
                          texttableentry: 'Consumer',
                        },
                      ],
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'BacNetGateway',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: '',
                      path: 'PA_Struc/PA_DevicFunct/PA_Funct',
                      unit: '',
                      dopname: '1 Byte TextTable EnergyMeter',
                      name: 'PA_Funct',
                      value: 'No',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        {
                          TI_texttableentry: 'TI_Source',
                          interval: '1',
                          texttableentry: 'Source',
                        },
                        {
                          TI_texttableentry: 'TI_Consumer',
                          interval: '2',
                          texttableentry: 'Consumer',
                        },
                      ],
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'ModbusGateway',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: '',
                      path: 'PA_Struc/PA_DevicFunct/PA_Funct',
                      unit: '',
                      dopname: '1 Byte TextTable EnergyMeter',
                      name: 'PA_Funct',
                      value: 'No',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        {
                          TI_texttableentry: 'TI_Source',
                          interval: '1',
                          texttableentry: 'Source',
                        },
                        {
                          TI_texttableentry: 'TI_Consumer',
                          interval: '2',
                          texttableentry: 'Consumer',
                        },
                      ],
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'Mbus',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'FriWaStation',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'FuelCell',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'CSC',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'Photovoltaic',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'ProductionGateway',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'DiagnosticGateway',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'SDIO',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable GenericSdioAccessoryFunction',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        {
                          TI_texttableentry: 'TI_Nothing',
                          interval: '0',
                          texttableentry: 'Nothing',
                        },
                        {
                          TI_texttableentry: 'TI_Individual',
                          interval: '1',
                          texttableentry: 'Individual',
                        },
                        { TI_texttableentry: 'TI_Solar', interval: '2', texttableentry: 'Solar' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'Nothing',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'MTWOIO',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path: 'PA_Struc/PA_DevicFunct/PA_Param',
                      unit: '',
                      dopname: '1 Byte TextTable GenericMTwoIoAccessoryModuleFunction',
                      name: 'PA_Param',
                      value: 'Nothing',
                      structure: [
                        {
                          TI_texttableentry: 'TI_Nothing',
                          interval: '0',
                          texttableentry: 'Nothing',
                        },
                        {
                          TI_texttableentry: 'TI_Individual',
                          interval: '1',
                          texttableentry: 'Individual',
                        },
                        {
                          TI_texttableentry: 'TI_Vitovalor',
                          interval: '4',
                          texttableentry: 'Vitovalor',
                        },
                      ],
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'RemoteControlLocal',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      path: 'PA_Struc/PA_DevicFunct/PA_RemotContrDevicFunct',
                      unit: '',
                      dopname: '1 Byte TextTable uint8 RemoteControlLocalFunction',
                      name: 'PA_RemotContrDevicFunct',
                      value: 'Nothing',
                      structure: [
                        {
                          TI_texttableentry: 'TI_Nothing',
                          interval: '0',
                          texttableentry: 'Nothing',
                        },
                        {
                          TI_texttableentry: 'TI_WeatherRoomControllerWired',
                          interval: '1',
                          texttableentry: 'WeatherRoomControllerWired',
                        },
                        {
                          TI_texttableentry: 'TI_WeatherControllerWired',
                          interval: '2',
                          texttableentry: 'WeatherControllerWired',
                        },
                        {
                          TI_texttableentry: 'TI_TimeScheduledControllerWired',
                          interval: '3',
                          texttableentry: 'TimeScheduledControllerWired',
                        },
                        {
                          TI_texttableentry: 'TI_WeatherRoomControllerWireless',
                          interval: '4',
                          texttableentry: 'WeatherRoomControllerWireless',
                        },
                        {
                          TI_texttableentry: 'TI_WeatherRoomControllerMasterWireless',
                          interval: '5',
                          texttableentry: 'WeatherRoomControllerMasterWireless',
                        },
                        {
                          TI_texttableentry: 'TI_WeatherRoomControllerSlaveWireless',
                          interval: '6',
                          texttableentry: 'WeatherRoomControllerSlaveWireless',
                        },
                      ],
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'ClimaSensor',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'TemperatureRadiatorValve',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'UnderfloorHeatingValve',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'EnergyMeter',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: '',
                      path: 'PA_Struc/PA_DevicFunct/PA_Funct',
                      unit: '',
                      dopname: '1 Byte TextTable EnergyMeter',
                      name: 'PA_Funct',
                      value: 'No',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        {
                          TI_texttableentry: 'TI_Source',
                          interval: '1',
                          texttableentry: 'Source',
                        },
                        {
                          TI_texttableentry: 'TI_Consumer',
                          interval: '2',
                          texttableentry: 'Consumer',
                        },
                      ],
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'EMCUMaster',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable DeviceFunctionEMCU',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        {
                          TI_texttableentry: 'TI_Nothing',
                          interval: '0',
                          texttableentry: 'Nothing',
                        },
                        {
                          TI_texttableentry: 'TI_Hybrid',
                          interval: '1',
                          texttableentry: 'Hybrid',
                        },
                        {
                          TI_texttableentry: 'TI_Photovoltaic',
                          interval: '2',
                          texttableentry: 'Photovoltaic',
                        },
                        {
                          TI_texttableentry: 'TI_Battery',
                          interval: '3',
                          texttableentry: 'Battery',
                        },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'Nothing',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'EMCUSlave',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable DeviceFunctionEMCU',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        {
                          TI_texttableentry: 'TI_Nothing',
                          interval: '0',
                          texttableentry: 'Nothing',
                        },
                        {
                          TI_texttableentry: 'TI_Hybrid',
                          interval: '1',
                          texttableentry: 'Hybrid',
                        },
                        {
                          TI_texttableentry: 'TI_Photovoltaic',
                          interval: '2',
                          texttableentry: 'Photovoltaic',
                        },
                        {
                          TI_texttableentry: 'TI_Battery',
                          interval: '3',
                          texttableentry: 'Battery',
                        },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'Nothing',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'BMCU',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable DeviceFunctionBMCU',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        {
                          TI_texttableentry: 'TI_Nothing',
                          interval: '0',
                          texttableentry: 'Nothing',
                        },
                        {
                          TI_texttableentry: 'TI_Vitocharge',
                          interval: '1',
                          texttableentry: 'Vitocharge',
                        },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'Nothing',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'HPMUMaster',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: '',
                      path: 'PA_Struc/PA_DevicFunct/PA_Funct',
                      unit: '',
                      dopname: '1 Byte TextTable DeviceFunctionHPMU',
                      name: 'PA_Funct',
                      value: 'Nothing',
                      structure: [
                        {
                          TI_texttableentry: 'TI_Nothing',
                          interval: '0',
                          texttableentry: 'Nothing',
                        },
                        {
                          TI_texttableentry: 'TI_VitocalOneHundredFiftyA',
                          interval: '1',
                          texttableentry: 'VitocalOneHundredFiftyA',
                        },
                        {
                          TI_texttableentry: 'TI_VitocalTwoHundredFiftyA',
                          interval: '2',
                          texttableentry: 'VitocalTwoHundredFiftyA',
                        },
                        {
                          TI_texttableentry: 'TI_VitocalTwoHundredS',
                          interval: '3',
                          texttableentry: 'VitocalTwoHundredS',
                        },
                        {
                          TI_texttableentry: 'TI_VitocalThreeHundredA',
                          interval: '4',
                          texttableentry: 'VitocalThreeHundredA',
                        },
                        {
                          TI_texttableentry: 'TI_VitocalThreeHundredG',
                          interval: '5',
                          texttableentry: 'VitocalThreeHundredG',
                        },
                        {
                          TI_texttableentry: 'TI_VitocalTwoHundredFiftyAH',
                          interval: '6',
                          texttableentry: 'VitocalTwoHundredFiftyAH',
                        },
                        {
                          TI_texttableentry: 'TI_VitocalTwoHundredSH',
                          interval: '7',
                          texttableentry: 'VitocalTwoHundredSH',
                        },
                        {
                          TI_texttableentry: 'TI_VitocalOneHundredFiftyOneA',
                          interval: '8',
                          texttableentry: 'VitocalOneHundredFiftyOneA',
                        },
                        {
                          TI_texttableentry: 'TI_VitocalTwoHundredFiftyTwoA',
                          interval: '9',
                          texttableentry: 'VitocalTwoHundredFiftyTwoA',
                        },
                        {
                          TI_texttableentry: 'TI_VitocalTwoHundredTwentyTwoS',
                          interval: '10',
                          texttableentry: 'VitocalTwoHundredTwentyTwoS',
                        },
                        {
                          TI_texttableentry: 'TI_VitocalTwoHundredTwentyOneS',
                          interval: '11',
                          texttableentry: 'VitocalTwoHundredTwentyOneS',
                        },
                      ],
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'HPMUSlave',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'VCMU',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'EHCU',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'MZIO',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable GenericMZIOAccessoryModuleFunction',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        {
                          TI_texttableentry: 'TI_Individual',
                          interval: '1',
                          texttableentry: 'Individual',
                        },
                        {
                          TI_texttableentry: 'TI_TemperatureDemand',
                          interval: '3',
                          texttableentry: 'TemperatureDemand',
                        },
                        {
                          TI_texttableentry: 'TI_ModulationDemand',
                          interval: '4',
                          texttableentry: 'ModulationDemand',
                        },
                        {
                          TI_texttableentry: 'TI_FaultSignal',
                          interval: '5',
                          texttableentry: 'FaultSignal',
                        },
                        {
                          TI_texttableentry: 'TI_FaultSignalAndTemperatureDemand',
                          interval: '6',
                          texttableentry: 'FaultSignalAndTemperatureDemand',
                        },
                        {
                          TI_texttableentry: 'TI_FaultSignalAndModulationDemand',
                          interval: '7',
                          texttableentry: 'FaultSignalAndModulationDemand',
                        },
                        {
                          TI_texttableentry: 'TI_SupplementalHeatRequest',
                          interval: '8',
                          texttableentry: 'SupplementalHeatRequest',
                        },
                        {
                          TI_texttableentry: 'TI_SupplementalHeatRequestAndTemperatureDemand',
                          interval: '9',
                          texttableentry: 'SupplementalHeatRequestAndTemperatureDemand',
                        },
                        {
                          TI_texttableentry: 'TI_SupplementalHeatRequestAndModulationDemand',
                          interval: '10',
                          texttableentry: 'SupplementalHeatRequestAndModulationDemand',
                        },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'Individual',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'PBE',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'HBMU',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: '',
                      path: 'PA_Struc/PA_DevicFunct/PA_Funct',
                      unit: '',
                      dopname: '1 Byte TextTable DeviceFunctionHBMU',
                      name: 'PA_Funct',
                      value: 'Nothing',
                      structure: [
                        {
                          TI_texttableentry: 'TI_Nothing',
                          interval: '0',
                          texttableentry: 'Nothing',
                        },
                        {
                          TI_texttableentry: 'TI_VitodensOneHundred',
                          interval: '1',
                          texttableentry: 'VitodensOneHundred',
                        },
                        {
                          TI_texttableentry: 'TI_VitodensFifty',
                          interval: '2',
                          texttableentry: 'VitodensFifty',
                        },
                      ],
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'OSME',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'TwoStepperMotor',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'Inverter',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'SmartRoomControl',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'ENUM',
                      path: 'PA_Struc/PA_DevicFunct/PA_Type',
                      unit: '',
                      dopname: '1 Byte TextTable uint8 SmartRoomControlHub',
                      name: 'PA_Type',
                      value: 'Nothing',
                      structure: [
                        {
                          TI_texttableentry: 'TI_Nothing',
                          interval: '0',
                          texttableentry: 'Nothing',
                        },
                        {
                          TI_texttableentry: 'TI_Integrated',
                          interval: '1',
                          texttableentry: 'Integrated',
                        },
                        {
                          TI_texttableentry: 'TI_External',
                          interval: '2',
                          texttableentry: 'External',
                        },
                      ],
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'VCUMaster',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'VCUSlave',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'CanOpenIOModule',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: '',
                      path: 'PA_Struc/PA_DevicFunct/PA_Funct',
                      unit: '',
                      dopname: '1 Byte TextTable EnergyMeter',
                      name: 'PA_Funct',
                      value: 'No',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        {
                          TI_texttableentry: 'TI_Source',
                          interval: '1',
                          texttableentry: 'Source',
                        },
                        {
                          TI_texttableentry: 'TI_Consumer',
                          interval: '2',
                          texttableentry: 'Consumer',
                        },
                      ],
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'Fan',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'ElectricalPreheater',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'ElectricalPostheater',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'GenericHeatPump',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable EebusInterface',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        {
                          TI_texttableentry: 'TI_Nothing',
                          interval: '0',
                          texttableentry: 'Nothing',
                        },
                        {
                          TI_texttableentry: 'TI_GenericHeatPump',
                          interval: '1',
                          texttableentry: 'GenericHeatPump',
                        },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'Nothing',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'HomeEnergyManagementSystem',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'EeBusHub',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'HIO',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'ENUMCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable GenericHioAccessoryModuleFunction',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        {
                          TI_texttableentry: 'TI_Nothing',
                          interval: '0',
                          texttableentry: 'Nothing',
                        },
                        {
                          TI_texttableentry: 'TI_Individual',
                          interval: '1',
                          texttableentry: 'Individual',
                        },
                        {
                          TI_texttableentry: 'TI_IntegrationExternalHeatgenerator',
                          interval: '2',
                          texttableentry: 'IntegrationExternalHeatgenerator',
                        },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'Nothing',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceObjectProperty',
                  byteposition: '2',
                  dopname: '1 Byte TextTable DeviceObjectProperty',
                  precision: '',
                  byteLength: '8',
                  type: 'eKEY',
                  shortname: 'PA_DevicObjecPrope',
                  constraints: '',
                  structure: [
                    { TI_texttableentry: 'TI_Nothing', interval: '0', texttableentry: 'Nothing' },
                    {
                      TI_texttableentry: 'TI_BackendGateway',
                      interval: '1',
                      texttableentry: 'BackendGateway',
                    },
                    {
                      TI_texttableentry: 'TI_HMUMaster',
                      interval: '2',
                      texttableentry: 'HMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HMUSlave',
                      interval: '3',
                      texttableentry: 'HMUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_MCUMaster',
                      interval: '4',
                      texttableentry: 'MCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_MCUSlave',
                      interval: '5',
                      texttableentry: 'MCUSlave',
                    },
                    { TI_texttableentry: 'TI_HMI', interval: '6', texttableentry: 'HMI' },
                    { TI_texttableentry: 'TI_BCU', interval: '7', texttableentry: 'BCU' },
                    {
                      TI_texttableentry: 'TI_GasAirRatioSystem',
                      interval: '8',
                      texttableentry: 'GasAirRatioSystem',
                    },
                    { TI_texttableentry: 'TI_ADIO', interval: '9', texttableentry: 'ADIO' },
                    { TI_texttableentry: 'TI_DIO', interval: '10', texttableentry: 'DIO' },
                    {
                      TI_texttableentry: 'TI_KnxGateway',
                      interval: '11',
                      texttableentry: 'KnxGateway',
                    },
                    {
                      TI_texttableentry: 'TI_BacNetGateway',
                      interval: '12',
                      texttableentry: 'BacNetGateway',
                    },
                    {
                      TI_texttableentry: 'TI_ModbusGateway',
                      interval: '13',
                      texttableentry: 'ModbusGateway',
                    },
                    { TI_texttableentry: 'TI_Mbus', interval: '14', texttableentry: 'Mbus' },
                    {
                      TI_texttableentry: 'TI_FriWaStation',
                      interval: '15',
                      texttableentry: 'FriWaStation',
                    },
                    {
                      TI_texttableentry: 'TI_FuelCell',
                      interval: '16',
                      texttableentry: 'FuelCell',
                    },
                    { TI_texttableentry: 'TI_CSC', interval: '17', texttableentry: 'CSC' },
                    {
                      TI_texttableentry: 'TI_Photovoltaic',
                      interval: '18',
                      texttableentry: 'Photovoltaic',
                    },
                    {
                      TI_texttableentry: 'TI_ProductionGateway',
                      interval: '19',
                      texttableentry: 'ProductionGateway',
                    },
                    {
                      TI_texttableentry: 'TI_DiagnosticGateway',
                      interval: '20',
                      texttableentry: 'DiagnosticGateway',
                    },
                    { TI_texttableentry: 'TI_SDIO', interval: '21', texttableentry: 'SDIO' },
                    { TI_texttableentry: 'TI_MTWOIO', interval: '22', texttableentry: 'MTWOIO' },
                    {
                      TI_texttableentry: 'TI_RemoteControlLocal',
                      interval: '23',
                      texttableentry: 'RemoteControlLocal',
                    },
                    {
                      TI_texttableentry: 'TI_ClimaSensor',
                      interval: '24',
                      texttableentry: 'ClimaSensor',
                    },
                    {
                      TI_texttableentry: 'TI_TemperatureRadiatorValve',
                      interval: '25',
                      texttableentry: 'TemperatureRadiatorValve',
                    },
                    {
                      TI_texttableentry: 'TI_UnderfloorHeatingValve',
                      interval: '26',
                      texttableentry: 'UnderfloorHeatingValve',
                    },
                    {
                      TI_texttableentry: 'TI_EnergyMeter',
                      interval: '27',
                      texttableentry: 'EnergyMeter',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUMaster',
                      interval: '28',
                      texttableentry: 'EMCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_EMCUSlave',
                      interval: '29',
                      texttableentry: 'EMCUSlave',
                    },
                    { TI_texttableentry: 'TI_BMCU', interval: '30', texttableentry: 'BMCU' },
                    {
                      TI_texttableentry: 'TI_HPMUMaster',
                      interval: '31',
                      texttableentry: 'HPMUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_HPMUSlave',
                      interval: '32',
                      texttableentry: 'HPMUSlave',
                    },
                    { TI_texttableentry: 'TI_VCMU', interval: '33', texttableentry: 'VCMU' },
                    { TI_texttableentry: 'TI_EHCU', interval: '34', texttableentry: 'EHCU' },
                    { TI_texttableentry: 'TI_MZIO', interval: '35', texttableentry: 'MZIO' },
                    { TI_texttableentry: 'TI_PBE', interval: '36', texttableentry: 'PBE' },
                    { TI_texttableentry: 'TI_HBMU', interval: '37', texttableentry: 'HBMU' },
                    { TI_texttableentry: 'TI_OSME', interval: '38', texttableentry: 'OSME' },
                    {
                      TI_texttableentry: 'TI_TwoStepperMotor',
                      interval: '39',
                      texttableentry: 'TwoStepperMotor',
                    },
                    {
                      TI_texttableentry: 'TI_Inverter',
                      interval: '40',
                      texttableentry: 'Inverter',
                    },
                    {
                      TI_texttableentry: 'TI_SmartRoomControl',
                      interval: '41',
                      texttableentry: 'SmartRoomControl',
                    },
                    {
                      TI_texttableentry: 'TI_VCUMaster',
                      interval: '42',
                      texttableentry: 'VCUMaster',
                    },
                    {
                      TI_texttableentry: 'TI_VCUSlave',
                      interval: '43',
                      texttableentry: 'VCUSlave',
                    },
                    {
                      TI_texttableentry: 'TI_CanOpenIOModule',
                      interval: '44',
                      texttableentry: 'CanOpenIOModule',
                    },
                    { TI_texttableentry: 'TI_Fan', interval: '45', texttableentry: 'Fan' },
                    {
                      TI_texttableentry: 'TI_ElectricalPreheater',
                      interval: '46',
                      texttableentry: 'ElectricalPreheater',
                    },
                    {
                      TI_texttableentry: 'TI_ElectricalPostheater',
                      interval: '47',
                      texttableentry: 'ElectricalPostheater',
                    },
                    {
                      TI_texttableentry: 'TI_GenericHeatPump',
                      interval: '48',
                      texttableentry: 'GenericHeatPump',
                    },
                    {
                      TI_texttableentry: 'TI_HomeEnergyManagementSystem',
                      interval: '49',
                      texttableentry: 'HomeEnergyManagementSystem',
                    },
                    {
                      TI_texttableentry: 'TI_EeBusHub',
                      interval: '50',
                      texttableentry: 'EeBusHub',
                    },
                    { TI_texttableentry: 'TI_HIO', interval: '51', texttableentry: 'HIO' },
                    {
                      TI_texttableentry: 'TI_BCUSlave',
                      interval: '52',
                      texttableentry: 'BCUSlave',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicObjecPrope',
                  unit: '',
                  translationid: 'TI_DeviceObjectProperty',
                  bitposition: '0',
                  name: 'PA_DevicObjecPrope',
                  value: 'BCUSlave',
                },
                {
                  semantic: 'ENUM',
                  longname: 'DeviceFunction',
                  byteposition: '3',
                  dopname: '1 Byte Table DeviceObjectProperty',
                  precision: '',
                  byteLength: '-1',
                  type: 'eTABLE',
                  shortname: 'PA_DevicFunct',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'BOOLEANCHOICE',
                      longname: 'Value',
                      byteposition: '0',
                      dopname: '1 Byte TextTable NoYes',
                      precision: '',
                      byteLength: '8',
                      type: 'eTEXTTABLE',
                      shortname: 'PA_Value',
                      constraints: '',
                      structure: [
                        { TI_texttableentry: 'TI_No', interval: '0', texttableentry: 'No' },
                        { TI_texttableentry: 'TI_Yes', interval: '1', texttableentry: 'Yes' },
                      ],
                      path: 'PA_Struc/PA_DevicFunct/PA_Value',
                      unit: '',
                      translationid: 'TI_Value',
                      bitposition: '0',
                      name: 'PA_Value',
                      value: 'No',
                    },
                  ],
                  path: 'PA_Struc/PA_DevicFunct',
                  unit: '',
                  translationid: 'TI_DeviceFunction',
                  bitposition: '0',
                  name: 'PA_DevicFunct',
                  value: '',
                },
                {
                  semantic: 'SOFTWAREVERSION',
                  longname: 'SoftwareVersion',
                  byteposition: '4',
                  dopname: '8 Byte Structure SoftwareVersion',
                  precision: '',
                  byteLength: '-1',
                  type: 'eSTRUCTURE',
                  shortname: 'PA_SoftwVersi',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'VERSIONVALUE',
                      longname: 'Family',
                      byteposition: '0',
                      dopname: '2 Byte Identical uint16',
                      precision: '',
                      byteLength: '16',
                      type: 'eA_UINT32',
                      shortname: 'PA_Famil',
                      constraints: '[0:65535]',
                      path: 'PA_Struc/PA_SoftwVersi/PA_Famil',
                      unit: '',
                      translationid: 'TI_Family',
                      bitposition: '0',
                      name: 'PA_Famil',
                      value: '0',
                    },
                    {
                      semantic: 'VERSIONVALUE',
                      longname: 'Version',
                      byteposition: '2',
                      dopname: '2 Byte Identical uint16',
                      precision: '',
                      byteLength: '16',
                      type: 'eA_UINT32',
                      shortname: 'PA_Versi',
                      constraints: '[0:65535]',
                      path: 'PA_Struc/PA_SoftwVersi/PA_Versi',
                      unit: '',
                      translationid: 'TI_Version',
                      bitposition: '0',
                      name: 'PA_Versi',
                      value: '0',
                    },
                    {
                      semantic: 'VERSIONVALUE',
                      longname: 'Revision',
                      byteposition: '4',
                      dopname: '2 Byte Identical uint16',
                      precision: '',
                      byteLength: '16',
                      type: 'eA_UINT32',
                      shortname: 'PA_Revis',
                      constraints: '[0:65535]',
                      path: 'PA_Struc/PA_SoftwVersi/PA_Revis',
                      unit: '',
                      translationid: 'TI_Revision',
                      bitposition: '0',
                      name: 'PA_Revis',
                      value: '0',
                    },
                    {
                      semantic: 'VERSIONVALUE',
                      longname: 'Build',
                      byteposition: '6',
                      dopname: '2 Byte Identical uint16',
                      precision: '',
                      byteLength: '16',
                      type: 'eA_UINT32',
                      shortname: 'PA_Build',
                      constraints: '[0:65535]',
                      path: 'PA_Struc/PA_SoftwVersi/PA_Build',
                      unit: '',
                      translationid: 'TI_Build',
                      bitposition: '0',
                      name: 'PA_Build',
                      value: '0',
                    },
                  ],
                  path: 'PA_Struc/PA_SoftwVersi',
                  unit: '',
                  translationid: 'TI_SoftwareVersion',
                  bitposition: '0',
                  name: 'PA_SoftwVersi',
                  value: '4',
                },
                {
                  semantic: 'HARDWAREVERSION',
                  longname: 'HardwareVersion',
                  byteposition: '12',
                  dopname: '8 Byte Structure HardwareVersion',
                  precision: '',
                  byteLength: '-1',
                  type: 'eSTRUCTURE',
                  shortname: 'PA_HardwVersi',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'VERSIONVALUE',
                      longname: 'Family',
                      byteposition: '0',
                      dopname: '2 Byte Identical uint16',
                      precision: '',
                      byteLength: '16',
                      type: 'eA_UINT32',
                      shortname: 'PA_Famil',
                      constraints: '[0:65535]',
                      path: 'PA_Struc/PA_HardwVersi/PA_Famil',
                      unit: '',
                      translationid: 'TI_Family',
                      bitposition: '0',
                      name: 'PA_Famil',
                      value: '0',
                    },
                    {
                      semantic: 'VERSIONVALUE',
                      longname: 'Version',
                      byteposition: '2',
                      dopname: '2 Byte Identical uint16',
                      precision: '',
                      byteLength: '16',
                      type: 'eA_UINT32',
                      shortname: 'PA_Versi',
                      constraints: '[0:65535]',
                      path: 'PA_Struc/PA_HardwVersi/PA_Versi',
                      unit: '',
                      translationid: 'TI_Version',
                      bitposition: '0',
                      name: 'PA_Versi',
                      value: '0',
                    },
                    {
                      semantic: 'VERSIONVALUE',
                      longname: 'Revision',
                      byteposition: '4',
                      dopname: '2 Byte Identical uint16',
                      precision: '',
                      byteLength: '16',
                      type: 'eA_UINT32',
                      shortname: 'PA_Revis',
                      constraints: '[0:65535]',
                      path: 'PA_Struc/PA_HardwVersi/PA_Revis',
                      unit: '',
                      translationid: 'TI_Revision',
                      bitposition: '0',
                      name: 'PA_Revis',
                      value: '0',
                    },
                    {
                      semantic: 'VERSIONVALUE',
                      longname: 'AssemblyVariant',
                      byteposition: '6',
                      dopname: '2 Byte Identical uint16',
                      precision: '',
                      byteLength: '16',
                      type: 'eA_UINT32',
                      shortname: 'PA_AssemVaria',
                      constraints: '[0:65535]',
                      path: 'PA_Struc/PA_HardwVersi/PA_AssemVaria',
                      unit: '',
                      translationid: 'TI_AssemblyVariant',
                      bitposition: '0',
                      name: 'PA_AssemVaria',
                      value: '0',
                    },
                  ],
                  path: 'PA_Struc/PA_HardwVersi',
                  unit: '',
                  translationid: 'TI_HardwareVersion',
                  bitposition: '0',
                  name: 'PA_HardwVersi',
                  value: '4',
                },
                {
                  semantic: 'TARCEABILITY',
                  longname: 'ElectronicTraceabilityNumber',
                  byteposition: '20',
                  dopname: '16 Byte Structure VinModul',
                  precision: '',
                  byteLength: '-1',
                  type: 'eSTRUCTURE',
                  shortname: 'PA_ElectTraceNumbe',
                  constraints: '',
                  structure: [
                    {
                      semantic: 'ITEMID',
                      longname: 'ItemId',
                      byteposition: '0',
                      dopname: '7 Byte Identical ItemId',
                      precision: '',
                      byteLength: '56',
                      type: 'eA_UNICODE2STRING',
                      shortname: 'PA_ItemId',
                      constraints: '[7:7]',
                      path: 'PA_Struc/PA_ElectTraceNumbe/PA_ItemId',
                      unit: '',
                      translationid: 'TI_ItemId',
                      bitposition: '0',
                      name: 'PA_ItemId',
                      value: '',
                    },
                    {
                      semantic: 'PRODUCTIONYEAR',
                      longname: 'Year',
                      byteposition: '7',
                      dopname: '1 Byte Identical uint8 ASCII',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UNICODE2STRING',
                      shortname: 'PA_Year',
                      constraints: '[1:1]',
                      path: 'PA_Struc/PA_ElectTraceNumbe/PA_Year',
                      unit: '',
                      translationid: 'TI_Year',
                      bitposition: '0',
                      name: 'PA_Year',
                      value: '',
                    },
                    {
                      semantic: 'COUNTER',
                      longname: 'ProcessCounter',
                      byteposition: '8',
                      dopname: '5 Byte Identical ProcessCounter',
                      precision: '',
                      byteLength: '40',
                      type: 'eA_UNICODE2STRING',
                      shortname: 'PA_ProceCount',
                      constraints: '[5:5]',
                      path: 'PA_Struc/PA_ElectTraceNumbe/PA_ProceCount',
                      unit: '',
                      translationid: 'TI_ProcessCounter',
                      bitposition: '0',
                      name: 'PA_ProceCount',
                      value: '',
                    },
                    {
                      semantic: 'COUNTER',
                      longname: 'OverflowCounterOne',
                      byteposition: '13',
                      dopname: '1 Byte Identical uint8 ASCII',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UNICODE2STRING',
                      shortname: 'PA_OverfCountOne',
                      constraints: '[1:1]',
                      path: 'PA_Struc/PA_ElectTraceNumbe/PA_OverfCountOne',
                      unit: '',
                      translationid: 'TI_OverflowCounterOne',
                      bitposition: '0',
                      name: 'PA_OverfCountOne',
                      value: '',
                    },
                    {
                      semantic: 'COUNTER',
                      longname: 'OverflowTwo',
                      byteposition: '14',
                      dopname: '1 Byte Identical uint8 ASCII',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UNICODE2STRING',
                      shortname: 'PA_OverfTwo',
                      constraints: '[1:1]',
                      path: 'PA_Struc/PA_ElectTraceNumbe/PA_OverfTwo',
                      unit: '',
                      translationid: 'TI_OverflowTwo',
                      bitposition: '0',
                      name: 'PA_OverfTwo',
                      value: '',
                    },
                    {
                      semantic: 'VALUE',
                      longname: 'Checksum',
                      byteposition: '15',
                      dopname: '1 Byte Identical uint8 ASCII',
                      precision: '',
                      byteLength: '8',
                      type: 'eA_UNICODE2STRING',
                      shortname: 'PA_Check',
                      constraints: '[1:1]',
                      path: 'PA_Struc/PA_ElectTraceNumbe/PA_Check',
                      unit: '',
                      translationid: 'TI_Checksum',
                      bitposition: '0',
                      name: 'PA_Check',
                      value: '',
                    },
                  ],
                  path: 'PA_Struc/PA_ElectTraceNumbe',
                  unit: '',
                  translationid: 'TI_ElectronicTraceabilityNumber',
                  bitposition: '0',
                  name: 'PA_ElectTraceNumbe',
                  value: '6',
                },
              ],
              path: 'PA_Struc',
              unit: '',
              translationid: '',
              bitposition: '0',
              name: 'PA_Struc',
              value: '',
            },
          ],
        },
      ],
    };
  }
}
